<template>
  <div>
    <div class="modal__content">
      <p class="text-center mb20">Are you sure you want to remove designer file from this task?</p>

      <div class="flex flex--justify-center">
        <button class="btn btn--wide btn--gray-2 mr10" @click="$bus.$emit('modalClose')" type="button">No</button>
        <button class="btn btn--wide" @click="onConfirm">Yes</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { apiRemoveDesignFileKey } from '@/api/task.api'

  export default {
    data () {
      return {
      }
    },

    props: {
      args: {
        type: Object,
        required: true
      }
    },

    methods: {
      ...mapActions([
        'updateActiveTaskProperties'
      ]),

      async onConfirm () {
        const projectID = this.$route.params.id
        const { key, taskId } = this.args
        
        const [err, data] = await apiRemoveDesignFileKey(projectID, taskId, key)

        this.$bus.$emit('modalClose')
        if (err) return errorMessage(err, 'Unable to add design!')

        return this.updateActiveTaskProperties({ taskId, 
          properties: { designerFileList: data.designerFileList }
        })

      }
    }
  }
</script>



// WEBPACK FOOTER //
// RemoveDesignerFilesModal.vue?c0999ea2